import {
    GET_FUEL_RECORDS,
    DELETE_FUEL_RECORD,
    UPDATE_FUEL_RECORD,
    SUBMIT_FUEL_RECORD,
    GET_ALL_FUEL_RECORDS,
} from '../actions/types';

export default function (state = [], action) {
    switch (action.type) {
        case GET_FUEL_RECORDS:
            return action.payload;
        case DELETE_FUEL_RECORD:
            return state.reduce((array, record) => {
                const deleteKey = action.payload;

                if (record.key !== deleteKey)
                    array.push(record);

                return array;
            }, []);
        case UPDATE_FUEL_RECORD:
            return state.reduce((array, record) => {
                const newRecord = action.payload;

                if (record.key === newRecord.key)
                    array.push(newRecord);
                else
                    array.push(record);

                return array;
            }, []);
        case GET_ALL_FUEL_RECORDS:
            return action.payload;
        case SUBMIT_FUEL_RECORD:
            return [...state, action.payload];
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/app/reducers/fuel_records_reducer.js